module.exports = __webpack_public_path__ + "static/media/scooter-brand-refresh.df9088ba.svg";